import {
  ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR,
  ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS,
  ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST,
  CREATE_MANUAL_ORDERS_REQUEST,
  CREATE_MANUAL_ORDERS_SUCCESS,
  CREATE_MANUAL_ORDERS_ERROR,
  RESET_ORDEROPPORTUNITIES_MANUAL_ORDER,
  RESET_CREATE_MANUAL_ORDER,
  RESET_CREATE_MANUAL_ORDER_ERROR,
  SEARCH_ORDEROPPORTUNITIES_REQUEST,
  SEARCH_ORDEROPPORTUNITIES_SUCCESS,
  SEARCH_ORDEROPPORTUNITIES_ERROR,
  SEARCH_ORDEROPPORTUNITIES_RESET,
} from "../actions/action-type";

const initalState = {
  orderOpportunitiesResponse: {},
  isorderOpportunitiesError: false,
  isorderOpportunitiesSuccess: false,
  isorderOpportunitiesLoading: false,
  createManualOrderResponse: [],
  isCreateManualOrderError: false,
  isCreateManualOrderSuccess: false,
  isCreateManualOrderLoading: false,
  searchOrderOpportunitiesResponse: {},
  isSearchOrderOpportunitiesError: false,
  isSearchOrderOpportunitiesSuccess: false,
  isSearchOrderOpportunitiesLoading: false,
  items: [],
  metadata: {},
  errorDetails: {},
};

const orderopportunitiesInCreateReducer = (
  state = initalState,
  {
    type,
    payload,
    createManualOrderResponse,
    searchOrderOpportunitiesResponse,
  }
) => {
  switch (type) {
    case ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST:
      return {
        ...state,
        isorderOpportunitiesLoading: true,
        isorderOpportunitiesError: false,
        isorderOpportunitiesSuccess: false,
      };
      case ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS:
          
          return {
            ...state,
            items: payload.items,
            metadata: payload.metadata,
            isorderOpportunitiesLoading: false,
            isorderOpportunitiesError: false,
            isorderOpportunitiesSuccess: true,
            errorDetails: {},
          };
    case ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR:
      return {
        ...state,
        isorderOpportunitiesLoading: false,
        isorderOpportunitiesError: true,
        isorderOpportunitiesSuccess: false,
        errorDetails: payload,
      };
    case RESET_ORDEROPPORTUNITIES_MANUAL_ORDER:
        return {
            ...initalState,
          };
    case CREATE_MANUAL_ORDERS_REQUEST:
      return {
        ...initalState,
        isCreateManualOrderLoading: true,
        isCreateManualOrderError: false,
        isCreateManualOrderSuccess: false,
      };
    case CREATE_MANUAL_ORDERS_SUCCESS:
      return {
        ...initalState,
        createManualOrderResponse: createManualOrderResponse,
        isCreateManualOrderLoading: false,
        isCreateManualOrderError: false,
        isCreateManualOrderSuccess: true,
      };
    case CREATE_MANUAL_ORDERS_ERROR:
      return {
        ...initalState,
        createManualOrderResponse: createManualOrderResponse,
        isCreateManualOrderLoading: false,
        isCreateManualOrderError: true,
        isCreateManualOrderSuccess: false,
      };
    case RESET_CREATE_MANUAL_ORDER:
      return {
        ...initalState,
      };
    case RESET_CREATE_MANUAL_ORDER_ERROR:
      return {
        ...state,
        isCreateManualOrderError: false,
        isCreateManualOrderSuccess: false,
      };
    case SEARCH_ORDEROPPORTUNITIES_REQUEST:
      return {
        ...initalState,
        isSearchOrderOpportunitiesLoading: true,
        isSearchOrderOpportunitiesError: false,
        isSearchOrderOpportunitiesSuccess: false,
      };
    case SEARCH_ORDEROPPORTUNITIES_SUCCESS:
      const { items: newOrders, metadata: newMetadata } = searchOrderOpportunitiesResponse;
      const { items: existingOrders } = state;
      let mergedOrders;
      if (existingOrders) {
          mergedOrders = [...existingOrders, ...newOrders];
      } else {
          mergedOrders = newOrders;
      }
      return {
          ...initalState,
          searchOrderOpportunitiesResponse: {
              items: mergedOrders,
              metadata: newMetadata
          },
          isSearchOrderOpportunitiesLoading: false,
          isSearchOrderOpportunitiesError: false,
          isSearchOrderOpportunitiesSuccess: true,
      };
    case SEARCH_ORDEROPPORTUNITIES_ERROR:
      return {
        ...initalState,
        searchOrderOpportunitiesResponse: searchOrderOpportunitiesResponse,
        isSearchOrderOpportunitiesLoading: false,
        isSearchOrderOpportunitiesError: true,
        isSearchOrderOpportunitiesSuccess: false,
      };
    case SEARCH_ORDEROPPORTUNITIES_RESET:
      return {
        ...initalState,
      };
    default:
      return state;
  }
};

export default orderopportunitiesInCreateReducer;
